const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const fullMonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export default function(date, full, year) {
    try {
        if (date == null) return ''
        if (typeof date === 'number')
            date = new Date(date)
        // if(new Date().getFullYear() !== date.getFullYear())
             year = true
        return (full ? fullMonth : months)[date.getMonth()] + ' ' + date.getDate() + (year ? (', ' + (1900 + date.getYear())) : '')
    } catch (error) {
        console.error('Problem calculating date', error)
    }
    
}
